<template>
  <div class="master-table-type">
    <el-table
      :fit="true"
      width="100%"
      :data="result"
      v-show="isShow">

      <!--  オーナーID -->
      <el-table-column
        class-name="col-2"
        prop="ownerEXId"
        :label="$t('label.system.building.search.result.ownerEXId')"/>

      <!--  オーナー名 -->
      <el-table-column
        class-name="col-3"
        prop="ownerName"
        :label="$t('label.system.building.search.result.ownerName')"/>

      <!--  ビルID -->
      <el-table-column
        class-name="col-2"
        prop="buildingExId"
        :label="$t('label.system.building.search.result.buildingEXId')"/>

      <!--  ビル名 -->
      <el-table-column
        class-name="col-3"
        prop="buildingName"
        :label="$t('label.system.building.search.result.buildingName')"/>

      <!--  住所 -->
      <el-table-column
        class-name="col-3"
        prop="address"
        :label="$t('label.system.building.search.result.address')"/>

      <!--  フロア数 -->
      <el-table-column
        class-name="col-3"
        prop="aboveFloorCount"
        :label="$t('label.system.building.search.result.floorsNumTotal')"/>

      <!--  照会バータン  -->
      <el-table-column class-name="col-2">
        <div slot-scope="scope" class="detail-button with-100">
          <!--  照会バータン  -->
          <sp-smart-button @click="handleDetailAction(scope.row)" class="detailed-but with-100">{{$t('button.common.detail')}}</sp-smart-button>
        </div>
      </el-table-column>

      <!--  削除バータン  -->
      <el-table-column class-name="col-2" class="text-right">
        <div slot-scope="scope" v-auth="{ auth: '010304'}" class="text-center">
          <el-popconfirm
            popper-class="iot-pop-confirm"
            :title="$t('message.system.owner.deleteConfirm')"
            :confirmButtonText="$t('button.common.ok')"
            :cancelButtonText="$t('button.common.cancel')"
            class="btn-operate"
            @onConfirm="handleDeleteAction(scope.row)">
            <sp-smart-button
              v-show="!scope.row.deleteFlag"
              slot="reference">
              {{$t("button.common.data.delete")}}
            </sp-smart-button>
          </el-popconfirm>
        </div>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
// import LvoryButM from "@/components/common/generalButton/LvoryButM"
import SpSmartButton from "@/components/common/sp-smart-button"
const EVENT_EDIT = "on-edit"
const EVENT_DETAIL = "on-detail"
const EVENT_DELETE = "on-delete"
const EVENT_FUNCTION_SETUP = "on-setup-function"
const EVENT_ELV_DETAIL = "on-elv-detail"
const EVENT_DATE_FUNCTION = "on-date-function"

export default {
  name: "BuilingSearchResultBeautify",
  components:{
    // LvoryButM
    SpSmartButton: SpSmartButton
  },
  data() {
    return {
      commands: {
        FUNCTION_SETUP: 1,
        ELV_DETAIL: 2,
        DATE_FUNCTION: 3
      }
    }
  },
  props: {
    result: Array,
    isShow: Boolean
  },
  methods: {
    //照会バータン
    handleDetailAction(owner) {
      this.$emit(EVENT_DETAIL, owner.buildingId)
    },
    //編集バータン
    handleEditAction(owner) {
      this.$emit(EVENT_EDIT, owner.buildingId)
    },
    //削除バータン
    handleDeleteAction(owner) {
      this.$emit(EVENT_DELETE, owner.buildingId)
    },
    handleOtherAction(command) {
      switch (command.action) {
        //機能設定
        case this.commands.FUNCTION_SETUP: {
          this.handleSetupFunction(command.owner)
          break
        }
        //ELVグループ照会
        case this.commands.ELV_DETAIL: {
          this.handleImportMachine(command.owner)
          break
        }
        //時間設定
        case this.commands.DATE_FUNCTION: {
          this.handleDateFunction(command.owner)
          break
        }
      }
    },
    handleSetupFunction(owner) {
      this.$emit(EVENT_FUNCTION_SETUP, owner.buildingId)
    },
    handleImportMachine(owner) {
      this.$emit(EVENT_ELV_DETAIL, owner.groupId)
    },
    handleDateFunction(owner) {
      this.$emit(EVENT_DATE_FUNCTION, owner.buildingId)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .my-button {
    width: 100% !important;
}

.btn-operate {
  margin: 0 5px 0 0;
}
.btn-operate-other {
  margin-left: 5px;
}

</style>
